import React from "react";
import Gif from "./images/animation_640_lj8fw28l.gif";
import styled from "styled-components";
import Image from "next/image";

const BlockWrap = styled.div`
  background-color: #ffffffd1;
  position: fixed;
  right: 20;
  top: 0;
  transition: background-color 0.5s;
  width: 100vw;
  height: 100vh;
  z-index: 10;
`;
const Img = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 45%;

  @media screen and (max-width: 767px) {
    left: 25%;
  }
`;


export default function Blocker() {
  return (
    <div>
      <BlockWrap>
        <Img><Image width={200} height={200} src={Gif} alt="Gif" /></Img>
      </BlockWrap>
    </div>
  );
}
